import { computed } from 'vue'
import { useSubscribedProducts } from '@/features/billing/composables/useSubscribedProducts'

/**
 * Whether the selected organization is known to have no subscription granting access.
 * False until an organization is selected: that isn't "no subscription".
 */
export function useHasNoSubscription() {
  const products = useSubscribedProducts()

  return computed(() => products.value?.length === 0)
}
